var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('intersect',{on:{"~enter":function($event){_vm.playAnimation = true}}},[_c('number',{ref:"anim",attrs:{"animationPaused":"","from":0,"to":_vm.value,"duration":_vm.duration/1000}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }